export const EPISODE_CALL_REQUEST = "EPISODE_CALL_REQUEST";
export const EPISODE_CALL_SUCCESS = "EPISODE_CALL_SUCCESS";
export const EPISODE_CALL_FAILURE = "EPISODE_CALL_FAILURE";
